import styled from 'styled-components';
import { globalFilterTokens } from '../../tokens/components/GlobalFilter/tokens';
import { TagElement } from '../Tag/styles';
import { StyledButton } from '../Button/Button';
import { StyledSideNavContentContainer } from '../SideNav/components/SideNavContentContainer/styles';
import { StyledSideNav } from '../SideNav/styles';

/* @internal */
export const TriggerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${globalFilterTokens.ToolbarGapBaseDefault};
`;

/* @internal */
export const GlobalFilterContainer = styled.div<{ $width: React.CSSProperties['width'] }>`
  width: ${({ $width }) => $width};
`;

/* @internal */
export const ToolbarWrapperContainer = styled.div`
  width: 100%;
  display: flex;
  height: ${({ theme }) => theme.toolbarHeight};
  margin: ${({ theme }) => theme.toolbarVerticalSpacing} 0;
`;

/* @internal */
export const ToolbarStack = styled.div`
  align-items: flex-start;
  flex-grow: 1;
  overflow: hidden;

  ${TagElement} {
    white-space: nowrap;
    margin-right: ${({ theme }) => theme.toolbarHorizontalSpacing};
  }
`;

/* @internal */
export const MoreWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  ${StyledButton} {
    min-height: 0;
    height: ${({ theme }) => theme.toolbarHeight};
  }
`;

/* @internal */
export const MeasurerWrapper = styled(MoreWrapper)`
  position: absolute;
  visibility: hidden;
  gap: ${({ theme }) => theme.toolbarHorizontalSpacing}; ;
`;

/* @internal */
export const FilterPanelWrapper = styled('aside')
  .withConfig<{ popover?: string }>({
    shouldForwardProp: (prop, defaultValidator) => prop === 'popover' || defaultValidator(prop),
  })
  .attrs({ popover: 'auto' })`
  border-color: ${globalFilterTokens.PanelBorderColorBaseDefault};
  border-radius: ${globalFilterTokens.PanelBorderRadiusBaseDefault};
  border-style: ${globalFilterTokens.PanelBorderStyleBaseDefault};
  border-width: ${globalFilterTokens.PanelBorderWidthBaseDefault};
  display: flex;
  flex-direction: row;
  height: 416px;
  inset: unset;
  margin-top: ${globalFilterTokens.PanelMarginTopBaseDefault};
  overflow-y: auto;
  position: absolute;
  width: min-content;
  z-index: ${globalFilterTokens.PanelElevationBaseDefault}};
`;

/* @internal */
export const FilterMenu = styled.div`
  background-color: ${globalFilterTokens.MenuBackgroundColorBaseDefault};
  border-right: ${globalFilterTokens.PanelBorderStyleBaseDefault} ${globalFilterTokens.PanelBorderColorBaseDefault};
  width: 180px;

  ${StyledSideNav} {
    padding-bottom: 8px;
  }

  ${StyledSideNavContentContainer} {
    padding-bottom: 0;
  }
`;

export const FilterView = styled.div`
  width: 380px;
  padding: ${globalFilterTokens.ViewPaddingVerticalBaseDefault} ${globalFilterTokens.ViewPaddingHorizontalBaseDefault};
  overflow-y: auto;
  background: ${globalFilterTokens.ViewBackgroundColorBaseDefault};
`;
